import styled, { css } from 'styled-components';

import { basicBodyTextStyle, basicSmallTextStyle, basicTransition, focusStyle } from '@dreryk/react-components';

export const StyledGifDecisionsCardListElementWrapper = styled.span`
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   gap: 4px;
   height: 36px;
   border-bottom: 1px solid ${(props) => props.theme.borderLight};
`;
StyledGifDecisionsCardListElementWrapper.displayName = 'StyledGifDecisionsCardListElementWrapper';

export const StyledGifDecisionsCardListElementColumn = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   overflow: hidden;
   width: 100%;
`;
StyledGifDecisionsCardListElementColumn.displayName = 'StyledGifDecisionsCardListElementColumn';

export const StyledGifDecisionsCardListElementLink = styled.a`
   ${basicBodyTextStyle}
   ${basicTransition}
   ${focusStyle}
   text-decoration: none;
   cursor: pointer;
   user-select: none;
   width: fit-content;
   max-width: 100%;
   font-weight: 700;

   ${({ theme }) => css`
      color: ${theme.primary};
      fill: ${theme.primary};

      &:focus-visible {
         box-shadow: 0 0 0 2px ${theme.primaryLighter};
      }

      &:hover {
         color: ${theme.primaryDark};
         fill: ${theme.primaryDark};
      }
   `}

   text-overflow: ellipsis;
   white-space: nowrap;
   overflow: hidden;
`;
StyledGifDecisionsCardListElementLink.displayName = 'StyledGifDecisionsCardListElementLink';

export const StyledGifDecisionsCardListElementDateAndEntityName = styled.div`
   ${basicSmallTextStyle}
   color: ${(props) => props.theme.border};
   margin-bottom: 2px;
   text-overflow: ellipsis;
   white-space: nowrap;
   overflow: hidden;
`;
StyledGifDecisionsCardListElementDateAndEntityName.displayName = 'StyledGifDecisionsCardListElementDateAndEntityName';
